import { render, staticRenderFns } from "./DropdownResponseSetModal.vue?vue&type=template&id=1ffc2f37&"
import script from "./DropdownResponseSetModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DropdownResponseSetModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports